import React, { Fragment } from 'react';
import { Link } from 'gatsby';
import { getTaxonomyUrl } from '../../utils/urls';
import Arrow from '../../images/icons/arrow.svg';

const ArchiveHeader = ({
  items,
  taxonomy,
  activeFilter,
  selectFilterText,
  urlPrefix,
  rootLink,
  rootText,
  clearText,
  openText,
  closeText,
  filterOpen,
  titleText,
  toggleFilterClick,
  renderActiveFilter,
  isSimple,
}) => {
  const currentObj = activeFilter && items.find(({ node }) => node.slug === activeFilter);
  const current = activeFilter && currentObj.node;
  const toggleText = filterOpen ? closeText : openText;

  return (
    <div className="archive-header">
      {!isSimple && (
        <Fragment>
          <div className="archive-header__selected">
            {!current && (
              <button type="button" className="archive-header__select-filter">
                {selectFilterText}
              </button>
            )}
            {current && (
              <span className="archive-header__current">
                {renderActiveFilter ? renderActiveFilter(current.name) : current.name}
              </span>
            )}
            {/* {current && (
          <Link className="archive-header__clear" to={rootLink}>
            <span className="archive-header__clear-text">{clearText}</span>
            <Arrow className="archive-header__clear-icon" />
          </Link>
        )} */}
            {
              <button
                type="button"
                className={`archive-header__toggle ${filterOpen ? 'archive-header__toggle--active' : ''}`}
                onClick={toggleFilterClick}
              >
                <span className="archive-header__toggle-text">{toggleText}</span>
                <Arrow className="archive-header__toggle-icon" />
              </button>
            }
          </div>
          <ul className={`archive-header__items${filterOpen ? ' archive-header__items--open' : ''}`}>
            <li className={`archive-header__item${!activeFilter ? ' archive-header__item--active' : ''}`}>
              <Link className="archive-header__link" to={rootLink}>
                {rootText}
              </Link>
            </li>
            {items.map(({ node }) => {
              const link = getTaxonomyUrl(urlPrefix, taxonomy, node.slug);

              return (
                <li
                  key={node.wordpress_id}
                  className={`archive-header__item${node.slug === activeFilter ? ' archive-header__item--active' : ''}`}
                >
                  <Link className="archive-header__link" to={link}>
                    {node.name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </Fragment>
      )}
      {isSimple && <strong className="archive-header__title">{titleText}</strong>}
    </div>
  );
};

export default ArchiveHeader;
